export function getCommonSelectorProps() {
  return {
    classNames: { menuPortal: () => "x-command-palette-menu" },
    menuIsOpen: true,
    forceOpen: true,
  };
}
